// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/fonts/dmsans-variablefont_opszwght-webfont.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("assets/fonts/dmsans-variablefont_opszwght-webfont.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("assets/fonts/dmsans-italic-variablefont_opszwght-webfont.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("assets/fonts/dmsans-italic-variablefont_opszwght-webfont.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "DM_Sans";
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_0___})
      format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "DM_Sans_Italic";
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_2___})
      format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___})
      format("woff");
  font-weight: normal;
  font-style: normal;
}

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

:root {
  --purple-100: hsl(254, 88%, 90%);
  --purple-500: hsl(256, 67%, 59%);

  --yellow-100: hsl(31, 66%, 93%);
  --yellow-500: hsl(39, 100%, 71%);

  --white: hsl(0, 0%, 100%);
  --black: hsl(0, 0%, 7%);

  --spacing-100: 0.5rem;
  --spacing-200: calc(var(--spacing-100) * 2);
  --spacing-300: calc(var(--spacing-100) * 3);
  --spacing-400: calc(var(--spacing-100) * 4);
  --spacing-500: calc(var(--spacing-100) * 5);
}

body {
  font-family: "DM_Sans", sans-serif;
  font-size: 1.125rem;
  font-weight: 400;
  line-height: 111%;
  letter-spacing: 0px;

  color: var(--black);
  background-color: #ddd;
}

/* TYPOGRAPHY */
.text-preset-1 {
  font-size: clamp(2.875rem, 2.5229rem + 1.5023vw, 3.875rem);
  line-height: 93.5%;
  letter-spacing: calc(-1 * clamp(0.125rem, 0.0536rem + 0.1488vw, 0.1875rem));
  font-weight: 500;
}

.text-preset-2 {
  font-size: clamp(2rem, 1.8239rem + 0.7512vw, 2.5rem);
  line-height: 90%;
  letter-spacing: -2px;
  font-weight: 500;
}

.text-preset-3 {
  font-size: clamp(1.625rem, 1.493rem + 0.5634vw, 2rem);
  line-height: 87.5%;
  letter-spacing: -2px;
  font-weight: 500;
}

.italic {
  font-family: "DM_Sans_Italic", sans-serif;
}

.yellow-text {
  color: var(--yellow-500);
}

.purple-text {
  color: var(--purple-500);
}

/* UTILITY CLASSES */
.container {
  max-width: 70rem;
  width: 90%;
  margin: 0 auto;
}

.card {
  border-radius: 10px;
  background-color: var(--white);
  text-align: center;
  padding: var(--spacing-400);

  display: flex;
  flex-direction: column;
  gap: var(--spacing-300);
}

.purple-bg {
  background-color: var(--purple-500);
  color: var(--white);
}

.light-purple-bg {
  background-color: var(--purple-100);
}

.yellow-bg {
  background-color: var(--yellow-500);
}

.light-yellow-bg {
  background-color: var(--yellow-100);
}

/* BENTO GRID */
.bento {
  padding: clamp(2.25rem, 1.2157rem + 4.4131vw, 5.1875rem) 0;

  .bento-grid,
  .bento-subgrid {
    display: grid;
    grid-template-columns: 1fr;
    gap: var(--spacing-400);
  }

  #card-2,
  #card-3,
  #card-6,
  #card-7,
  #card-8 {
    text-align: start;
  }

  #card-1 {
    padding-top: var(--spacing-500);
    .content {
      max-width: 30rem;
      margin: 0 auto;

      display: flex;
      flex-direction: column;
      gap: var(--spacing-300);
    }
    img {
      max-width: 13.8125rem;
      margin: 0 auto;
    }
  }

  #card-2 {
    gap: var(--spacing-200);
    padding: var(--spacing-200);
  }

  #card-3 {
    padding: var(--spacing-200) var(--spacing-200) 0;
    overflow: hidden;
    gap: var(--spacing-200);
    img {
      margin-bottom: -1.3125rem;
      max-width: 13rem;
    }
  }

  #card-4 {
    padding-inline: 1.0625rem;
    img,
    p {
      max-width: 22.3125rem;
      margin: 0 auto;
    }
  }

  #card-5 {
    padding: 1.5rem 3rem;
    gap: var(--spacing-500);

    img {
      max-width: 14.25rem;
    }
  }

  #card-6 {
    img {
      max-width: 11.125rem;
    }

    .text {
      display: flex;
      flex-direction: column;
      gap: var(--spacing-200);
    }
  }

  #card-7 {
    img {
      max-width: 11.875rem;
    }
  }

  #card-8 {
    padding: var(--spacing-300);

    img {
      max-width: 13.75rem;
    }
  }
}

@media (min-width: 48rem) {
  .bento {
    .bento-grid,
    .bento-subgrid {
      grid-template-columns: repeat(2, 1fr);
    }

    .bento-subgrid {
      grid-column: span 2;
    }

    #card-1,
    #card-4,
    #card-5,
    #card-6 {
      grid-column: span 2;
    }

    #card-2 {
      justify-content: space-between;
      h2 {
        max-width: 13rem;
      }
      img {
        margin-right: calc(-1 * var(--spacing-200));
      }
    }

    #card-3 {
      img {
        margin-bottom: 0;
      }
    }

    #card-5 {
      flex-direction: row;
      align-items: center;
      padding-inline: 5.125rem;
      text-align: start;
    }

    #card-6 {
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }

    #card-7 {
      justify-content: center;
    }
  }
}

@media (min-width: 90rem) {
  .bento {
    .bento-grid {
      grid-template-columns: repeat(4, 1fr);
    }

    #card-1 {
      grid-column: 2 / span 2;
    }

    #card-2 {
      grid-row: 2;
      grid-column: 2;

      padding: 1.5rem;
      overflow: hidden;
      img {
        width: 19.75rem;
        margin-right: -5.25rem;
      }
    }

    #card-3 {
      grid-row: 2;
      grid-column: 3;
      padding: 1.5rem 1.5rem 0;

      img {
        margin-bottom: -3.875rem;
      }
    }

    #card-4 {
      text-align: start;
      justify-content: space-between;
      grid-column: 4;
      grid-row: 1 / span 2;
      overflow: hidden;
      padding: 3rem 2rem;
      img {
        width: auto;
        margin-right: -8.3125rem;
      }
    }

    #card-5 {
      grid-row: 3;
      grid-column: 3 / span 2;

      padding-inline: 1.5rem;
      gap: 0.75rem;
    }

    #card-6 {
      grid-row: 3;
      grid-column: 2;

      flex-direction: column;
      align-items: flex-start;

      padding: 1.5rem;
      gap: 2.5rem;
    }

    .bento-subgrid {
      grid-column: 1;
      grid-row: 1 / span 3;
      grid-template-columns: 1fr;
      grid-template-rows: 1fr auto;
    }

    #card-8 {
      justify-content: space-between;
      align-self: stretch;
      gap: 3.5rem;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB;;;0DAG8E;EAC9E,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B;;;;oBAIkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;;EAEhC,+BAA+B;EAC/B,gCAAgC;;EAEhC,yBAAyB;EACzB,uBAAuB;;EAEvB,qBAAqB;EACrB,2CAA2C;EAC3C,2CAA2C;EAC3C,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;;EAEnB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,eAAe;AACf;EACE,0DAA0D;EAC1D,kBAAkB;EAClB,2EAA2E;EAC3E,gBAAgB;AAClB;;AAEA;EACE,oDAAoD;EACpD,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,2BAA2B;;EAE3B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA,eAAe;AACf;EACE,0DAA0D;;EAE1D;;IAEE,aAAa;IACb,0BAA0B;IAC1B,uBAAuB;EACzB;;EAEA;;;;;IAKE,iBAAiB;EACnB;;EAEA;IACE,+BAA+B;IAC/B;MACE,gBAAgB;MAChB,cAAc;;MAEd,aAAa;MACb,sBAAsB;MACtB,uBAAuB;IACzB;IACA;MACE,qBAAqB;MACrB,cAAc;IAChB;EACF;;EAEA;IACE,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,gDAAgD;IAChD,gBAAgB;IAChB,uBAAuB;IACvB;MACE,yBAAyB;MACzB,gBAAgB;IAClB;EACF;;EAEA;IACE,yBAAyB;IACzB;;MAEE,qBAAqB;MACrB,cAAc;IAChB;EACF;;EAEA;IACE,oBAAoB;IACpB,uBAAuB;;IAEvB;MACE,mBAAmB;IACrB;EACF;;EAEA;IACE;MACE,oBAAoB;IACtB;;IAEA;MACE,aAAa;MACb,sBAAsB;MACtB,uBAAuB;IACzB;EACF;;EAEA;IACE;MACE,oBAAoB;IACtB;EACF;;EAEA;IACE,2BAA2B;;IAE3B;MACE,mBAAmB;IACrB;EACF;AACF;;AAEA;EACE;IACE;;MAEE,qCAAqC;IACvC;;IAEA;MACE,mBAAmB;IACrB;;IAEA;;;;MAIE,mBAAmB;IACrB;;IAEA;MACE,8BAA8B;MAC9B;QACE,gBAAgB;MAClB;MACA;QACE,2CAA2C;MAC7C;IACF;;IAEA;MACE;QACE,gBAAgB;MAClB;IACF;;IAEA;MACE,mBAAmB;MACnB,mBAAmB;MACnB,wBAAwB;MACxB,iBAAiB;IACnB;;IAEA;MACE,mBAAmB;MACnB,mBAAmB;MACnB,8BAA8B;IAChC;;IAEA;MACE,uBAAuB;IACzB;EACF;AACF;;AAEA;EACE;IACE;MACE,qCAAqC;IACvC;;IAEA;MACE,uBAAuB;IACzB;;IAEA;MACE,WAAW;MACX,cAAc;;MAEd,eAAe;MACf,gBAAgB;MAChB;QACE,eAAe;QACf,sBAAsB;MACxB;IACF;;IAEA;MACE,WAAW;MACX,cAAc;MACd,wBAAwB;;MAExB;QACE,wBAAwB;MAC1B;IACF;;IAEA;MACE,iBAAiB;MACjB,8BAA8B;MAC9B,cAAc;MACd,oBAAoB;MACpB,gBAAgB;MAChB,kBAAkB;MAClB;QACE,WAAW;QACX,wBAAwB;MAC1B;IACF;;IAEA;MACE,WAAW;MACX,uBAAuB;;MAEvB,sBAAsB;MACtB,YAAY;IACd;;IAEA;MACE,WAAW;MACX,cAAc;;MAEd,sBAAsB;MACtB,uBAAuB;;MAEvB,eAAe;MACf,WAAW;IACb;;IAEA;MACE,cAAc;MACd,oBAAoB;MACpB,0BAA0B;MAC1B,4BAA4B;IAC9B;;IAEA;MACE,8BAA8B;MAC9B,mBAAmB;MACnB,WAAW;IACb;EACF;AACF","sourcesContent":["@font-face {\n  font-family: \"DM_Sans\";\n  src:\n    url(\"assets/fonts/dmsans-variablefont_opszwght-webfont.woff2\")\n      format(\"woff2\"),\n    url(\"assets/fonts/dmsans-variablefont_opszwght-webfont.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"DM_Sans_Italic\";\n  src:\n    url(\"assets/fonts/dmsans-italic-variablefont_opszwght-webfont.woff2\")\n      format(\"woff2\"),\n    url(\"assets/fonts/dmsans-italic-variablefont_opszwght-webfont.woff\")\n      format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n* {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n\n:root {\n  --purple-100: hsl(254, 88%, 90%);\n  --purple-500: hsl(256, 67%, 59%);\n\n  --yellow-100: hsl(31, 66%, 93%);\n  --yellow-500: hsl(39, 100%, 71%);\n\n  --white: hsl(0, 0%, 100%);\n  --black: hsl(0, 0%, 7%);\n\n  --spacing-100: 0.5rem;\n  --spacing-200: calc(var(--spacing-100) * 2);\n  --spacing-300: calc(var(--spacing-100) * 3);\n  --spacing-400: calc(var(--spacing-100) * 4);\n  --spacing-500: calc(var(--spacing-100) * 5);\n}\n\nbody {\n  font-family: \"DM_Sans\", sans-serif;\n  font-size: 1.125rem;\n  font-weight: 400;\n  line-height: 111%;\n  letter-spacing: 0px;\n\n  color: var(--black);\n  background-color: #ddd;\n}\n\n/* TYPOGRAPHY */\n.text-preset-1 {\n  font-size: clamp(2.875rem, 2.5229rem + 1.5023vw, 3.875rem);\n  line-height: 93.5%;\n  letter-spacing: calc(-1 * clamp(0.125rem, 0.0536rem + 0.1488vw, 0.1875rem));\n  font-weight: 500;\n}\n\n.text-preset-2 {\n  font-size: clamp(2rem, 1.8239rem + 0.7512vw, 2.5rem);\n  line-height: 90%;\n  letter-spacing: -2px;\n  font-weight: 500;\n}\n\n.text-preset-3 {\n  font-size: clamp(1.625rem, 1.493rem + 0.5634vw, 2rem);\n  line-height: 87.5%;\n  letter-spacing: -2px;\n  font-weight: 500;\n}\n\n.italic {\n  font-family: \"DM_Sans_Italic\", sans-serif;\n}\n\n.yellow-text {\n  color: var(--yellow-500);\n}\n\n.purple-text {\n  color: var(--purple-500);\n}\n\n/* UTILITY CLASSES */\n.container {\n  max-width: 70rem;\n  width: 90%;\n  margin: 0 auto;\n}\n\n.card {\n  border-radius: 10px;\n  background-color: var(--white);\n  text-align: center;\n  padding: var(--spacing-400);\n\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-300);\n}\n\n.purple-bg {\n  background-color: var(--purple-500);\n  color: var(--white);\n}\n\n.light-purple-bg {\n  background-color: var(--purple-100);\n}\n\n.yellow-bg {\n  background-color: var(--yellow-500);\n}\n\n.light-yellow-bg {\n  background-color: var(--yellow-100);\n}\n\n/* BENTO GRID */\n.bento {\n  padding: clamp(2.25rem, 1.2157rem + 4.4131vw, 5.1875rem) 0;\n\n  .bento-grid,\n  .bento-subgrid {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: var(--spacing-400);\n  }\n\n  #card-2,\n  #card-3,\n  #card-6,\n  #card-7,\n  #card-8 {\n    text-align: start;\n  }\n\n  #card-1 {\n    padding-top: var(--spacing-500);\n    .content {\n      max-width: 30rem;\n      margin: 0 auto;\n\n      display: flex;\n      flex-direction: column;\n      gap: var(--spacing-300);\n    }\n    img {\n      max-width: 13.8125rem;\n      margin: 0 auto;\n    }\n  }\n\n  #card-2 {\n    gap: var(--spacing-200);\n    padding: var(--spacing-200);\n  }\n\n  #card-3 {\n    padding: var(--spacing-200) var(--spacing-200) 0;\n    overflow: hidden;\n    gap: var(--spacing-200);\n    img {\n      margin-bottom: -1.3125rem;\n      max-width: 13rem;\n    }\n  }\n\n  #card-4 {\n    padding-inline: 1.0625rem;\n    img,\n    p {\n      max-width: 22.3125rem;\n      margin: 0 auto;\n    }\n  }\n\n  #card-5 {\n    padding: 1.5rem 3rem;\n    gap: var(--spacing-500);\n\n    img {\n      max-width: 14.25rem;\n    }\n  }\n\n  #card-6 {\n    img {\n      max-width: 11.125rem;\n    }\n\n    .text {\n      display: flex;\n      flex-direction: column;\n      gap: var(--spacing-200);\n    }\n  }\n\n  #card-7 {\n    img {\n      max-width: 11.875rem;\n    }\n  }\n\n  #card-8 {\n    padding: var(--spacing-300);\n\n    img {\n      max-width: 13.75rem;\n    }\n  }\n}\n\n@media (min-width: 48rem) {\n  .bento {\n    .bento-grid,\n    .bento-subgrid {\n      grid-template-columns: repeat(2, 1fr);\n    }\n\n    .bento-subgrid {\n      grid-column: span 2;\n    }\n\n    #card-1,\n    #card-4,\n    #card-5,\n    #card-6 {\n      grid-column: span 2;\n    }\n\n    #card-2 {\n      justify-content: space-between;\n      h2 {\n        max-width: 13rem;\n      }\n      img {\n        margin-right: calc(-1 * var(--spacing-200));\n      }\n    }\n\n    #card-3 {\n      img {\n        margin-bottom: 0;\n      }\n    }\n\n    #card-5 {\n      flex-direction: row;\n      align-items: center;\n      padding-inline: 5.125rem;\n      text-align: start;\n    }\n\n    #card-6 {\n      flex-direction: row;\n      align-items: center;\n      justify-content: space-between;\n    }\n\n    #card-7 {\n      justify-content: center;\n    }\n  }\n}\n\n@media (min-width: 90rem) {\n  .bento {\n    .bento-grid {\n      grid-template-columns: repeat(4, 1fr);\n    }\n\n    #card-1 {\n      grid-column: 2 / span 2;\n    }\n\n    #card-2 {\n      grid-row: 2;\n      grid-column: 2;\n\n      padding: 1.5rem;\n      overflow: hidden;\n      img {\n        width: 19.75rem;\n        margin-right: -5.25rem;\n      }\n    }\n\n    #card-3 {\n      grid-row: 2;\n      grid-column: 3;\n      padding: 1.5rem 1.5rem 0;\n\n      img {\n        margin-bottom: -3.875rem;\n      }\n    }\n\n    #card-4 {\n      text-align: start;\n      justify-content: space-between;\n      grid-column: 4;\n      grid-row: 1 / span 2;\n      overflow: hidden;\n      padding: 3rem 2rem;\n      img {\n        width: auto;\n        margin-right: -8.3125rem;\n      }\n    }\n\n    #card-5 {\n      grid-row: 3;\n      grid-column: 3 / span 2;\n\n      padding-inline: 1.5rem;\n      gap: 0.75rem;\n    }\n\n    #card-6 {\n      grid-row: 3;\n      grid-column: 2;\n\n      flex-direction: column;\n      align-items: flex-start;\n\n      padding: 1.5rem;\n      gap: 2.5rem;\n    }\n\n    .bento-subgrid {\n      grid-column: 1;\n      grid-row: 1 / span 3;\n      grid-template-columns: 1fr;\n      grid-template-rows: 1fr auto;\n    }\n\n    #card-8 {\n      justify-content: space-between;\n      align-self: stretch;\n      gap: 3.5rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
